

























































import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  Account,
  Address,
  AggregateTransaction,
  CosignatureTransaction,
  Transaction,
  TransactionGroup,
  TransactionHttp,
} from 'symbol-sdk';
import AppConfig from '@/libs/AppConfig';

@Component({
  components: {
  },
})
export default class PartialTransactionModal extends Vue {
  @Prop()
  public transaction?: Transaction;

  @Prop()
  public cosignatories: Address[] = [];

  @Prop()
  public signedCosignatories: Address[] = [];

  @Prop()
  public closeDialog!: Function;

  private cosignatoryKey = '';

  private signerAddress = '';

  private cosignButtonDisable = true;

  private networkType = AppConfig.networkType();

  private cosignatoriesLink(a: Address) {
    return `http://explorer.testnet.symboldev.network/accounts/${a.plain()}`;
  }

  private onChangeCosinatorieskey() {
    const signerAccount = Account.createFromPrivateKey(this.cosignatoryKey, this.networkType);
    this.signerAddress = signerAccount.address.pretty();
    this.cosignButtonDisable = false;
  }

  private cosinatoryIcon(a: Address) {
    if (this.isSigned(a)) {
      return 'mdi-account-check';
    }
    return 'mdi-account-alert';
  }

  private isSigned(a: Address) {
    let flag = false;
    this.signedCosignatories.forEach((cos) => {
      if (cos.plain() === a.plain()) flag = true;
    });
    return flag;
  }

  private async onClickCosign() {
    try {
      const account = Account.createFromPrivateKey(this.cosignatoryKey, this.networkType);
      const transactionHttp = new TransactionHttp(AppConfig.apiEndpoint());
      const txHash = this.transaction?.transactionInfo?.hash || '';
      const txs = await transactionHttp
        .getTransactionsById([txHash], TransactionGroup.Partial).toPromise();
      if (txs.length) {
        const tx = txs[0] as AggregateTransaction;
        const cosignatureTransaction = CosignatureTransaction.create(tx);
        const signedTx = account.signCosignatureTransaction(cosignatureTransaction);
        transactionHttp.announceAggregateBondedCosignature(signedTx).subscribe((x) => {
          this.cosignatoryKey = '';
          this.signerAddress = '';
        }, (err) => {
          throw (err);
        });
      }
    } catch (err) {
      console.error(err);
    }
  }
}
